import withParams from "@src/components/widgets/HOC/withParams";
import React, { useCallback, useEffect, useState } from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetIntroductionParams } from "../interface";
import LandingHeaderIntroduction from "design-system/src/Components/WidgetPart/LandingHeaderIntroduction/LandingHeaderIntroduction";
import usePageLang from "@src/hooks/usePageLang";
import { AvailableLanguage } from "design-system/src/Interface/logoLang";
import { responsiveMap } from "design-system/src/Components/Grid/_utils/responsiveObserve";
import { scrollToNextLandingBlock } from "../scrollToNextLandingBlock";

const Introduction: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetIntroductionParams>((props) => {
    const { p } = props;
    const posterDesktop = p("poster_desktop");
    const posterMobile = p("poster_mobile");
    const logoSource = p("logo_source") || "image";
    const lang = usePageLang();
    const [hasNextBlock, setHasNextBlock] = useState(false);

    useEffect(() => {
      if (typeof document === "undefined") return;
      const introInstance = document.querySelector(
        '.widget-instance[data-template="introduction"]'
      );
      setHasNextBlock(!!introInstance?.nextElementSibling);
    }, []);

    const scrollToNextBlock = useCallback(() => {
      scrollToNextLandingBlock(
        '.widget-instance[data-template="introduction"]'
      );
    }, []);

    return (
      <>
        <style
          dangerouslySetInnerHTML={{
            __html: `
            @media ${responsiveMap.mobile} {
              .widget-collection.is-page .widget-layout-0 .widget-instance[data-template="introduction"] {
                padding-top: 0 !important;
              }
            }
            `,
          }}
        />
        <LandingHeaderIntroduction
          title={p("title") || ""}
          posterDesktopId={posterDesktop}
          posterMobileId={posterMobile}
          logoId={p("logo")}
          logoSource={logoSource}
          svgLogo={p("svg_logo")}
          svgLogoFile={p("svg_logo_file")}
          lang={lang as AvailableLanguage}
          onScrollHintClick={hasNextBlock ? scrollToNextBlock : undefined}
        />
      </>
    );
  });

export default Introduction;
